"use strict";

// https://splidejs.com/guides/options/#fixedheight
import Splide from '@splidejs/splide';

const Slider = {
    init: function() {
        document.addEventListener('DOMContentLoaded', function (event) {

            [...document.querySelectorAll('.homepage__slider .splide')].forEach(homepageSlider => {
                new Splide('.homepage__slider .splide', {
                    type: 'loop',
                    drag: true,
                    autoplay: true,
                    interval: 10000,
                    resetProgress: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    direction: 'ttb',
                    heightRatio: 0.33, // required when direction is set to ttb. not ideal.
                    breakpoints: {
                        768: {
                            heightRatio: 1,
                        },
                  }
                }).mount();
            });

            [...document.querySelectorAll('.sponsors__slider .splide')].forEach(sponsorsSlider => {
                new Splide('.sponsors__slider .splide', {
                    perPage: 3,
                    perMove: 1,
                    rewind: true,
                    pagination: false,
                    gap: '2em',
                    drag: true,
                    autoplay: true,
                    interval: 10000,
                    resetProgress: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    autoWidth: false,
                    fixedHeight: '200px',
                    breakpoints: {
                        1024: {
                            perPage: 2,
                            gap: '1em',
                        },
                        640: {
                            perPage: 1,
                            gap: 0
                        }
                    }
                }).mount();
            });

        });
    }
}

Slider.init();
